import React from "react";
import { styled, SxProps } from "@mui/material";

export type ErrorIconProps = {
  sx?: SxProps;
  icon?: React.ReactNode;
  color?: "red" | "green" | "blue";
};

const PendingIcon: React.FC<ErrorIconProps> = (props) => {
  const { icon, color, ...otherProps } = props;

  if (color === "green")
    otherProps.sx = {
      ...otherProps.sx,
      background: "linear-gradient(180deg, rgba(0, 255 , 0, 0) 0%, rgba(0,255,0, 0.17) 100%)",
    };
  else if (color === "red")
    otherProps.sx = {
      ...otherProps.sx,
      background: "linear-gradient(180deg, rgba(255 , 0 , 0 , 0) 0%, rgba(255 , 0 , 0 , 0.17) 100%)",
    };
  else if (color === "blue")
    otherProps.sx = {
      ...otherProps.sx,
      background: `linear-gradient(180deg, rgba(45, 108, 225, 0) 0%, rgba(45, 108, 225, 0.17) 100%)`,
    };

  return (
    <Illustration {...otherProps}>
      <img src="/static/images/empty-list.svg" alt="" width={68} height={62} />
      {icon}
    </Illustration>
  );
};

export default PendingIcon;

const Illustration = styled("figure")(({ theme }) => ({
  position: "relative",
  width: 150,
  height: 150,
  borderRadius: "100%",
  background: "linear-gradient(180deg, rgba(255, 179, 0, 0) 0%, rgba(255, 179, 0, 0.17) 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  img: {
    position: "absolute",
    top: -40,
  },
  ".MuiSvgIcon-root": {
    fontSize: 80,
  },
}));
